import { imageConfigValues } from "../config/config";

export const convertToBase64 = (file, cb) => {
  const reader = new FileReader();
  const img = new Image();
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  let factor;
  const maxPixels = imageConfigValues.IMAGE_MAX_PIXEL_WIDTH_OR_HEIGHT;
  if (file) {
    switch (file?.type) {
      case "application/pdf":
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          cb(e.target.result);
        };
        break;
      default:
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          img.type = "image/jpg";
          img.src = reader.result;
          img.onload = () => {
            if (img.width > maxPixels || img.height > maxPixels) {
              if (img.width > img.height) {
                factor = img.width / maxPixels;
              } else {
                factor = img.height / maxPixels;
              }
              canvas.width = img.width / factor;
              canvas.height = img.height / factor;
              ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
              img.src = canvas.toDataURL("image/jpeg", 1);
              img.onload = () => {
                cb(img.src);
              };
            } else {
              cb(img.src);
            }
          };
        };
        break;
    }
  }
  reader.onerror = (error) => {
    console.log("Error on convertToBase64: ", error);
  };
};
